import React from 'react';
import styled from 'styled-components';
import { StyledButton1 } from '../Common/Buttons/StyledButtons';
import { KindredIcon } from '../Common/Icons';
import { PoweredByKindred, useLanguageUtm } from '../Common';
import { useHistory } from 'react-router-dom';
import env from '../env';
import { useTranslation } from 'react-i18next';
import usePageTitle from '../Common/Hooks/usePageTitle';
import { usePartnerSamsungQueryParamExtraction } from './utils';

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  padding: 1rem 1.5rem;

  & > #description {
    text-align: center;
    width: 100%;
  }
`;

const Heading = styled.h3`
  margin: 5px 0;
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const Description = styled.p`
  text-align: left;
`;

const SamsungLanding: React.FC = () => {
  useLanguageUtm();
  usePageTitle();
  usePartnerSamsungQueryParamExtraction();

  const history = useHistory();
  const { t } = useTranslation();

  return (
    <Container>
      <div id="beforeLogo">
        <p></p>
      </div>
      <LogoContainer id="logo">
        <KindredIcon color="purple" />
      </LogoContainer>
      <div id="afterLogo">
        <p></p>
      </div>
      <div id="beforeDescription">
        <p></p>
      </div>
      <div id="description">
        <Heading>{t('samsung.landing.title')}</Heading>
        <Description>{t('samsung.landing.description')}</Description>
        <StyledButton1
          onClick={() => {
            if (env.samsung_plugin_install_link) {
              window.location.href = env.samsung_plugin_install_link;
            }
          }}
          borderRadius="0"
          marginBottom={10}
          marginTop={20}
          padding="1rem"
        >
          {t('samsung.landing.install')}
        </StyledButton1>
        <PoweredByKindred hasInfo />
      </div>
      <div id="afterDescription">
        <p></p>
      </div>
    </Container>
  );
};

export default SamsungLanding;
